<template>
  <div class="error">
    <div class="error__content">
      <img
        class="error__icon"
        src="//static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/error.png"
      />
      <div class="error__text">{{ text }}</div>
      <div class="error__btn" @click="reload">重试</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheError",
  props: {
    text: {
      type: String,
      default: "网络异常",
    },
  },
  methods: {
    reload() {
      location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.error {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #fff;

  &__content {
    position: absolute;
    top: 50%;
    width: 100%;
    font-size: 14px;
    text-align: center;
    transform: translateY(-50%);
  }

  &__icon {
    display: block;
    width: 250px;
    margin: 0 auto;
  }

  &__text {
    margin-top: 12px;
    color: #5b6169;
  }

  &__btn {
    width: 140px;
    height: 40px;
    margin: 20px auto;
    line-height: 40px;
    color: #fff;
    background: #eb002a;
    border-radius: 20px;
  }
}
</style>
